import { NoddiRating, RatingButton, useIsWithinTailWindBreakpoint } from 'noddi-ui-web';

interface RatingComponentProps {
  rating: number | null;
  setRating?: (value: number | null) => void;
  label: string;
  showDivider?: boolean;
  readOnly?: boolean;
}

export function RatingComponent({
  rating,
  setRating,
  label,
  showDivider = true,
  readOnly = false
}: RatingComponentProps) {
  const isLg = useIsWithinTailWindBreakpoint('lg');
  const starSize = isLg ? 'medium' : 'large';

  const handleValueChange = (newValue: number) => {
    setRating?.(newValue);
  };

  return (
    <div className='flex flex-col gap-1'>
      <span> {label}</span>
      <NoddiRating
        value={rating ?? 0}
        {...(!readOnly && { onValueChange: handleValueChange })}
        className='gap-1'
        readOnly={readOnly}
      >
        {Array.from({ length: 5 }).map((_, index) => (
          <RatingButton key={index} size={starSize} />
        ))}
      </NoddiRating>
      {showDivider && <div className='mt-2 h-px bg-outlineStroke' />}
    </div>
  );
}
